"use client";

import { c as _c } from "react/compiler-runtime";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, CheckIcon, Columns4Icon, Grid2X2Icon, XIcon } from "lucide-react";
import useSWR from "swr";
import { collectionBrowseAction } from "@/actions/collection";
import { Button } from "@/components/ui/button";
import { NULL_STR } from "@/lib/constants";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { useDebounce } from "@/ui/hooks/use-debounced-value";
import { useRouterRefresh } from "@/ui/hooks/use-router-refresh";
import { Label } from "@/ui/shadcn/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/shadcn/select";
import { StatefulSlider } from "@/ui/stateful-slider";
import { YnsLink } from "@/ui/yns-link";
import { useStartGlobalTransition } from "@/zustand/admin";
import { CompactButtonGroup } from "../../shared/compact-button-group";
import { ASPECT_RATIO_OPTIONS } from "../../shared/form-options";
export const ProductGridForm = t0 => {
  const $ = _c(138);
  const {
    data,
    props
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keepPreviousData: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: collections
  } = useSWR("getCollectionsAction", _temp, t1);
  const context = useStoreBuilderContext();
  const refresh = useRouterRefresh();
  const startGlobalTransition = useStartGlobalTransition();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      value: "left",
      icon: <AlignLeftIcon className="size-3" />,
      tooltip: "Align left"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      value: "center",
      icon: <AlignCenterIcon className="size-3" />,
      tooltip: "Align center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [t2, t3, {
      value: "right",
      icon: <AlignRightIcon className="size-3" />,
      tooltip: "Align right"
    }];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const alignmentOptions = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      value: "grid",
      icon: <Grid2X2Icon className="size-3" />,
      tooltip: "Grid"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [t5, {
      value: "carousel",
      icon: <Columns4Icon className="size-3" />,
      tooltip: "Carousel"
    }];
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const productLayoutOptions = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      value: "true",
      icon: <CheckIcon className="size-3" />,
      tooltip: "Enabled"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [t7, {
      value: "false",
      icon: <XIcon className="size-3" />,
      tooltip: "Disabled"
    }];
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const enabledOptions = t8;
  let t9;
  if ($[8] !== context || $[9] !== refresh || $[10] !== startGlobalTransition) {
    t9 = async v => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "first",
        value: v[0]
      });
      await refresh();
    });
    $[8] = context;
    $[9] = refresh;
    $[10] = startGlobalTransition;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleFirstChange = useDebounce(t9, 200);
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">{"Layout & Display"}</div>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-xs text-neutral-600 font-medium">Grid / Carousel</span>;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== context) {
    t12 = value => {
      context.saveSelectedPageSectionField({
        fieldPath: "productLayout",
        value
      });
    };
    $[14] = context;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== data.productLayout || $[17] !== t12) {
    t13 = <div className="grid gap-1">{t11}<CompactButtonGroup options={productLayoutOptions} defaultValue={data.productLayout} onValueChange={t12} className="w-full" /></div>;
    $[16] = data.productLayout;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-xs text-neutral-600 font-medium">Aspect Ratio</span>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = data.aspectRatio ?? "1/1";
  let t16;
  if ($[20] !== context) {
    t16 = value_0 => {
      context.saveSelectedPageSectionField({
        fieldPath: "aspectRatio",
        value: value_0
      });
    };
    $[20] = context;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t15 || $[23] !== t16) {
    t17 = <div className="grid gap-1">{t14}<CompactButtonGroup options={ASPECT_RATIO_OPTIONS} defaultValue={t15} onValueChange={t16} className="w-full" /></div>;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t13 || $[26] !== t17) {
    t18 = <div className="grid grid-cols-2 gap-2">{t13}{t17}</div>;
    $[25] = t13;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span className="text-xs text-neutral-600 font-medium">Product Count</span>;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== data.first) {
    t20 = [data.first];
    $[29] = data.first;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== handleFirstChange || $[32] !== t20) {
    t21 = <Label className="grid gap-2">{t19}<StatefulSlider defaultValue={t20} min={1} max={24} onValueChange={handleFirstChange} /></Label>;
    $[31] = handleFirstChange;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="text-xs text-neutral-600 font-medium">Columns</span>;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      value: "2",
      icon: <span className="text-xs font-medium">2</span>,
      tooltip: "2 columns"
    };
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      value: "3",
      icon: <span className="text-xs font-medium">3</span>,
      tooltip: "3 columns"
    };
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      value: "4",
      icon: <span className="text-xs font-medium">4</span>,
      tooltip: "4 columns"
    };
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = [t23, t24, t25, {
      value: "6",
      icon: <span className="text-xs font-medium">6</span>,
      tooltip: "6 columns"
    }];
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  const t27 = data.columns || 3;
  let t28;
  if ($[39] !== t27) {
    t28 = t27.toString();
    $[39] = t27;
    $[40] = t28;
  } else {
    t28 = $[40];
  }
  let t29;
  if ($[41] !== context || $[42] !== refresh || $[43] !== startGlobalTransition) {
    t29 = async value_1 => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "columns",
        value: Number.parseInt(value_1)
      });
      await refresh();
    });
    $[41] = context;
    $[42] = refresh;
    $[43] = startGlobalTransition;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t28 || $[46] !== t29) {
    t30 = <div className="grid gap-1">{t22}<CompactButtonGroup options={t26} defaultValue={t28} onValueChange={t29} className="w-full" /></div>;
    $[45] = t28;
    $[46] = t29;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  let t31;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <span className="text-xs text-neutral-600 font-medium">Mobile Columns</span>;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  let t32;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      value: "1",
      icon: <span className="text-xs font-medium">1</span>,
      tooltip: "1 column"
    };
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = [t32, {
      value: "2",
      icon: <span className="text-xs font-medium">2</span>,
      tooltip: "2 columns"
    }];
    $[50] = t33;
  } else {
    t33 = $[50];
  }
  const t34 = data.mobileColumns || 1;
  let t35;
  if ($[51] !== t34) {
    t35 = t34.toString();
    $[51] = t34;
    $[52] = t35;
  } else {
    t35 = $[52];
  }
  let t36;
  if ($[53] !== context || $[54] !== refresh || $[55] !== startGlobalTransition) {
    t36 = async value_2 => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "mobileColumns",
        value: Number.parseInt(value_2)
      });
      await refresh();
    });
    $[53] = context;
    $[54] = refresh;
    $[55] = startGlobalTransition;
    $[56] = t36;
  } else {
    t36 = $[56];
  }
  let t37;
  if ($[57] !== t35 || $[58] !== t36) {
    t37 = <div className="grid gap-1">{t31}<CompactButtonGroup options={t33} defaultValue={t35} onValueChange={t36} className="w-full" /></div>;
    $[57] = t35;
    $[58] = t36;
    $[59] = t37;
  } else {
    t37 = $[59];
  }
  let t38;
  if ($[60] !== t30 || $[61] !== t37) {
    t38 = <div className="grid grid-cols-2 gap-2">{t30}{t37}</div>;
    $[60] = t30;
    $[61] = t37;
    $[62] = t38;
  } else {
    t38 = $[62];
  }
  let t39;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <span className="text-xs text-neutral-600 font-medium">Column Gap</span>;
    $[63] = t39;
  } else {
    t39 = $[63];
  }
  const t40 = data.columnGap ?? "sm";
  let t41;
  if ($[64] !== context) {
    t41 = value_3 => {
      context.saveSelectedPageSectionField({
        fieldPath: "columnGap",
        value: value_3
      });
    };
    $[64] = context;
    $[65] = t41;
  } else {
    t41 = $[65];
  }
  let t42;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <SelectTrigger className="w-full"><SelectValue placeholder="Select gap size" /></SelectTrigger>;
    $[66] = t42;
  } else {
    t42 = $[66];
  }
  let t43;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <SelectContent><SelectItem value="sm">Small</SelectItem><SelectItem value="md">Medium</SelectItem><SelectItem value="lg">Large</SelectItem></SelectContent>;
    $[67] = t43;
  } else {
    t43 = $[67];
  }
  let t44;
  if ($[68] !== t40 || $[69] !== t41) {
    t44 = <div className="grid gap-1">{t39}<Select defaultValue={t40} onValueChange={t41}>{t42}{t43}</Select></div>;
    $[68] = t40;
    $[69] = t41;
    $[70] = t44;
  } else {
    t44 = $[70];
  }
  let t45;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <span className="text-xs text-neutral-600 font-medium">Alignment</span>;
    $[71] = t45;
  } else {
    t45 = $[71];
  }
  const t46 = data?.alignment ?? "left";
  let t47;
  if ($[72] !== context) {
    t47 = value_4 => {
      context.saveSelectedPageSectionField({
        fieldPath: "alignment",
        value: value_4
      });
    };
    $[72] = context;
    $[73] = t47;
  } else {
    t47 = $[73];
  }
  let t48;
  if ($[74] !== t46 || $[75] !== t47) {
    t48 = <div className="grid gap-1">{t45}<CompactButtonGroup options={alignmentOptions} defaultValue={t46} onValueChange={t47} className="w-full" /></div>;
    $[74] = t46;
    $[75] = t47;
    $[76] = t48;
  } else {
    t48 = $[76];
  }
  let t49;
  if ($[77] !== t44 || $[78] !== t48) {
    t49 = <div className="grid grid-cols-2 gap-2">{t44}{t48}</div>;
    $[77] = t44;
    $[78] = t48;
    $[79] = t49;
  } else {
    t49 = $[79];
  }
  let t50;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <span className="text-xs text-neutral-600 font-medium">Cart Button on Hover</span>;
    $[80] = t50;
  } else {
    t50 = $[80];
  }
  let t51;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      value: "visible",
      icon: <CheckIcon className="size-3" />,
      tooltip: "Visible"
    };
    $[81] = t51;
  } else {
    t51 = $[81];
  }
  let t52;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = [t51, {
      value: "hidden",
      icon: <XIcon className="size-3" />,
      tooltip: "Hidden"
    }];
    $[82] = t52;
  } else {
    t52 = $[82];
  }
  const t53 = data?.addToCartButtonVisibility ?? "visible";
  let t54;
  if ($[83] !== context) {
    t54 = value_5 => {
      context.saveSelectedPageSectionField({
        fieldPath: "addToCartButtonVisibility",
        value: value_5
      });
    };
    $[83] = context;
    $[84] = t54;
  } else {
    t54 = $[84];
  }
  let t55;
  if ($[85] !== t53 || $[86] !== t54) {
    t55 = <div className="grid gap-1">{t50}<CompactButtonGroup options={t52} defaultValue={t53} onValueChange={t54} className="w-full" /></div>;
    $[85] = t53;
    $[86] = t54;
    $[87] = t55;
  } else {
    t55 = $[87];
  }
  let t56;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <span className="text-xs text-neutral-600 font-medium">Show Pagination</span>;
    $[88] = t56;
  } else {
    t56 = $[88];
  }
  let t57;
  if ($[89] !== data.pagination) {
    t57 = data.pagination?.toString() ?? "false";
    $[89] = data.pagination;
    $[90] = t57;
  } else {
    t57 = $[90];
  }
  let t58;
  if ($[91] !== context || $[92] !== refresh || $[93] !== startGlobalTransition) {
    t58 = async value_6 => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "pagination",
        value: value_6
      });
      await refresh();
    });
    $[91] = context;
    $[92] = refresh;
    $[93] = startGlobalTransition;
    $[94] = t58;
  } else {
    t58 = $[94];
  }
  let t59;
  if ($[95] !== t57 || $[96] !== t58) {
    t59 = <div className="grid gap-1">{t56}<CompactButtonGroup options={enabledOptions} defaultValue={t57} onValueChange={t58} className="w-full" /></div>;
    $[95] = t57;
    $[96] = t58;
    $[97] = t59;
  } else {
    t59 = $[97];
  }
  let t60;
  if ($[98] !== t55 || $[99] !== t59) {
    t60 = <div className="grid grid-cols-2 gap-2">{t55}{t59}</div>;
    $[98] = t55;
    $[99] = t59;
    $[100] = t60;
  } else {
    t60 = $[100];
  }
  let t61;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <span className="text-xs text-neutral-600 font-medium">Show Sorting</span>;
    $[101] = t61;
  } else {
    t61 = $[101];
  }
  let t62;
  if ($[102] !== data.enableSorting) {
    t62 = data.enableSorting?.toString() ?? "false";
    $[102] = data.enableSorting;
    $[103] = t62;
  } else {
    t62 = $[103];
  }
  let t63;
  if ($[104] !== context || $[105] !== refresh || $[106] !== startGlobalTransition) {
    t63 = async value_7 => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "enableSorting",
        value: value_7
      });
      await refresh();
    });
    $[104] = context;
    $[105] = refresh;
    $[106] = startGlobalTransition;
    $[107] = t63;
  } else {
    t63 = $[107];
  }
  let t64;
  if ($[108] !== t62 || $[109] !== t63) {
    t64 = <div className="grid grid-cols-2 gap-2"><div className="grid gap-1">{t61}<CompactButtonGroup options={enabledOptions} defaultValue={t62} onValueChange={t63} className="w-full" /></div></div>;
    $[108] = t62;
    $[109] = t63;
    $[110] = t64;
  } else {
    t64 = $[110];
  }
  let t65;
  if ($[111] !== t18 || $[112] !== t21 || $[113] !== t38 || $[114] !== t49 || $[115] !== t60 || $[116] !== t64) {
    t65 = <div>{t10}<div className="space-y-4">{t18}{t21}{t38}{t49}{t60}{t64}</div></div>;
    $[111] = t18;
    $[112] = t21;
    $[113] = t38;
    $[114] = t49;
    $[115] = t60;
    $[116] = t64;
    $[117] = t65;
  } else {
    t65 = $[117];
  }
  let t66;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Content</div>;
    $[118] = t66;
  } else {
    t66 = $[118];
  }
  let t67;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <span className="text-xs text-neutral-600 font-medium">Collection</span>;
    $[119] = t67;
  } else {
    t67 = $[119];
  }
  const t68 = (collections?.data?.length || "") + (props.slug || "");
  const t69 = props.slug || (!data.collection ? NULL_STR : data.collection);
  const t70 = !collections?.data?.length || !!props.slug;
  let t71;
  if ($[120] !== context) {
    t71 = async value_8 => {
      await context.saveSelectedPageSectionField({
        fieldPath: "collection",
        value: value_8
      });
    };
    $[120] = context;
    $[121] = t71;
  } else {
    t71 = $[121];
  }
  let t72;
  if ($[122] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <SelectTrigger className="w-full"><SelectValue placeholder="Select a collection" /></SelectTrigger>;
    $[122] = t72;
  } else {
    t72 = $[122];
  }
  let t73;
  if ($[123] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = <SelectItem value={NULL_STR}>(None)</SelectItem>;
    $[123] = t73;
  } else {
    t73 = $[123];
  }
  let t74;
  if ($[124] !== collections?.data) {
    t74 = collections?.data?.map(_temp2);
    $[124] = collections?.data;
    $[125] = t74;
  } else {
    t74 = $[125];
  }
  let t75;
  if ($[126] !== t74) {
    t75 = <SelectContent>{t73}{t74}</SelectContent>;
    $[126] = t74;
    $[127] = t75;
  } else {
    t75 = $[127];
  }
  let t76;
  if ($[128] !== t68 || $[129] !== t69 || $[130] !== t70 || $[131] !== t71 || $[132] !== t75) {
    t76 = <div>{t66}<div className="space-y-4"><Label className="grid gap-1">{t67}<Select key={t68} defaultValue={t69} disabled={t70} onValueChange={t71}>{t72}{t75}</Select></Label></div></div>;
    $[128] = t68;
    $[129] = t69;
    $[130] = t70;
    $[131] = t71;
    $[132] = t75;
    $[133] = t76;
  } else {
    t76 = $[133];
  }
  let t77;
  if ($[134] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <Button asChild={true} className="w-max mt-8" variant="outline"><YnsLink href="/admin/products">Go to Add Products</YnsLink></Button>;
    $[134] = t77;
  } else {
    t77 = $[134];
  }
  let t78;
  if ($[135] !== t65 || $[136] !== t76) {
    t78 = <div className="space-y-6">{t65}{t76}{t77}</div>;
    $[135] = t65;
    $[136] = t76;
    $[137] = t78;
  } else {
    t78 = $[137];
  }
  return t78;
};
function _temp() {
  return collectionBrowseAction();
}
function _temp2(collection) {
  return <SelectItem value={collection.slug} key={collection.slug}>{collection.name}</SelectItem>;
}